export function toDataTestIdSlug(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[:/\\]+/g, '-')
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function prefixedTestId(prefix, suffix) {
  if (!prefix || !suffix) return undefined;
  return `${prefix}-${suffix}`;
}
